import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation updateCallsheetAnalysis($id: ID!, $input: CallsheetAnalysisUpdate!) {
    updateCallsheetAnalysis(id: $id, input: $input) {
      ...callsheetAnalysisDetail
    }
  }
  ${fragments.callsheetAnalysisDetail}
  ${fragments.kgraphDetail}
  ${fragments.personDetail}
  ${fragments.companyDetail}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.contactDetail}
  ${fragments.profession}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
  ${fragments.personArtworks}
  ${fragments.artworkToArtifacts}
  ${fragments.artworkDetails}
`;
